import { api } from '@/lib/api';
import { HistoricoPagamento, StatusPagamento } from '@/types';

export interface CreateHistoricoPagamentoRequest {
  feedbackId: string;
  tituloId: string;
  valorNegociado: number;
  valorPago?: number;
  dataPagamento?: string;
  statusPagamento?: StatusPagamento;
  formaPagamento?: string;
  observacoes?: string;
  comprovanteId?: string;
}

export interface UpdateHistoricoPagamentoRequest {
  id: string;
  valorPago?: number;
  dataPagamento?: string;
  statusPagamento?: StatusPagamento;
  formaPagamento?: string;
  observacoes?: string;
  comprovanteId?: string;
}

export const PaymentHistoryService = {
  async create(payload: CreateHistoricoPagamentoRequest) {
    const res = await api.post('/historico-pagamento', payload);
    return res.data.data as HistoricoPagamento;
  },

  async update(id: string, payload: UpdateHistoricoPagamentoRequest) {
    const res = await api.put(`/historico-pagamento/${id}`, payload);
    return res.data.data as HistoricoPagamento;
  },

  async findByFeedback(feedbackId: string) {
    const res = await api.get(`/historico-pagamento/feedback/${feedbackId}`);
    return (res.data.data as HistoricoPagamento[]) || [];
  },

  async findByTitulo(tituloId: string) {
    const res = await api.get(`/historico-pagamento/titulo/${tituloId}`);
    return (res.data.data as HistoricoPagamento[]) || [];
  },

  async getPaymentStats(params: { companyId: string; startDate?: string; endDate?: string }) {
    const search = new URLSearchParams();
    search.append('companyId', params.companyId);
    if (params.startDate) search.append('startDate', params.startDate);
    if (params.endDate) search.append('endDate', params.endDate);
    const res = await api.get(`/historico-pagamento/stats/payments?${search.toString()}`);
    return res.data.data as Array<{ statusPagamento: StatusPagamento; _sum: { valorNegociado: number | null; valorPago: number | null }; _count: { id: number } }>;
  },

  async getConversionRate(params: { companyId: string; startDate?: string; endDate?: string }) {
    const search = new URLSearchParams();
    search.append('companyId', params.companyId);
    if (params.startDate) search.append('startDate', params.startDate);
    if (params.endDate) search.append('endDate', params.endDate);
    const res = await api.get(`/historico-pagamento/stats/conversion-rate?${search.toString()}`);
    return res.data.data as { totalNegociacoes: number; pagamentosConfirmados: number; pagamentosParciais: number; taxaConversao: number };
  },
};


